export default {
  COMPLETED_PROGRAMS: 'COMPLETED_PROGRAMS',
  STUDY_PROGRAMS: 'STUDY_PROGRAMS',

  COMPLETED_TRIAL_PROGRAMS: 'COMPLETED_TRIAL_PROGRAMS',
  STUDY_TRIAL_PROGRAMS: 'STUDY_TRIAL_PROGRAMS',

  COURSE_PROGRAM_LESSONS: 'COURSE_PROGRAM_LESSONS',
  COURSE_PROGRAM_DETAILS: 'COURSE_PROGRAM_DETAILS',

  START_FETCHING_PROFILE: 'START_FETCHING_PROFILE',
  STOP_FETCHING_PROFILE: 'STOP_FETCHING_PROFILE',
};